<template>
<div id="header-wap">
    <div class="header">
        <div class="header-left">

            <div class="logo-a" @click="$router.push('/home')">
                <img class="logo" src="../../static/image/head_logo.jpg" alt="">
            </div>

            <el-select class="select" v-model="cityName" filterable placeholder="全国">
                <el-option v-for="item in cityList" :key="item.city_name" :label="item.city_name" :value="item.city_name">
                </el-option>
            </el-select>
        </div>

        <div class="header-right">
            <!-- <div class="personal" @click="toAuthorize">
                <span>个人中心</span>
            </div> -->
        </div>
    </div>
    <div class="nav">
        <router-link to="/home">首页</router-link>
        <router-link to="/gocat" :class="{active:isActive}">GO车惠</router-link>
       <router-link to="/news" :class="{news:isNews}">新闻资讯</router-link>
        <router-link to="/testdrive" :class="{test:isTest}" >试驾测评</router-link>
        <!-- <router-link to="/honest">诚信商家</router-link> -->
        <router-link to="/review" :class="{review:isReview}">往期回顾</router-link>
    </div>

</div>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            cityList: [],
            cityName: '',
            isActive: null,
            isNews:null,
            isTest:null,
            isReview:null
        }
    },

    mounted() {
        this.changeCity();
        this.$bus.$on('actived', (obj) => {
            this.isActive = obj.isActive
        })
          this.$bus.$on('news', (obj) => {
            this.isNews = obj.isNews
        })
        this.$bus.$on('test', (obj) => {
            this.isTest = obj.isTest
        })
        this.$bus.$on('review', (obj) => {
            this.isReview = obj.isReview
        })
    },
    methods: {
        async changeCity() {
            const result = await this.$http.home.getCityInfo();
            if (result.code === 200) {

                this.cityList = result.data
            } else {
                // this.$message({
                //   message: '暂无数据。。。',
                //   type: 'error',
                //   center: true
                // })
                return
            }

        },
        async toAuthorize() {
            // const result = await this.$http.home.getAuthorize()
            // console.log(result)
            this.$router.push('/personal')
        }
    }
}
</script>

<style lang="less">
#header-wap {
    width: 100%;

    .header {
        height: 100px;
        display: flex;
        padding: 0 30px;
        justify-content: space-between;
        align-items: center;
        font-size: 30px;
        margin-bottom: 16px;

        .header-left {
            // width: 140px;
            display: flex;
            align-items: center;
            padding-top: 10px;

            .logo-a {
                display: block;
                width: 180px;
                height: 100px;
                padding-top: 14px;

                .logo {

                    width: 100%;
                    display: block;
                }
            }

            .city {
                img {
                    width: 30px;
                    height: 30px;
                }

                margin-right: 2px;
            }

            .el-select {
                width: 160px;

                height: 60px;

                // border-radius: 20px;
                .el-input--suffix {
                    height: 100%;
                    padding-left: 4px;

                    .el-input__inner {
                        color: #000;
                        height: 100%;
                        // border: none;
                        padding: 0;
                        font-size: 30px;
                        border: 1px solid #CF0D28;
                        border-radius: 30px;
                        text-align: center;
                    }
                }

                .el-input__inner::placeholder {
                    color: #000;
                }
            }

        }

        .header-right {

            .icon-geren {
                font-size: 40px;
            }

        }

    }

    .nav {
        background: #efefef;
        height: 80px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 32px;
        font-weight: 500;

        a.router-link-active {
            color: red;
        }

        a.active {
            color: red;
        }
         a.news{
            color: red;
        }
        a.test{
            color: red;
        }
        a.review{
            color: red;
        }
    }

    .search {
        height: 70px;
        padding: 0 4px;
        position: relative;

        .search-input {
            width: 100%;
            height: 100%;
            border: 2px #c5c3c3 solid;
            padding-left: 60px;
            font-size: 30px;
        }

        .icon-sousuo {
            position: absolute;
            top: 15px;
            left: 10px;
            font-size: 50px;
        }
    }
}
</style>
